import { IBasicCommandResponse } from "./ah.mb.client-notifications";
import { FetchWrapper } from "../infrastructure/fetch-wrapper";
import * as moment from "moment";

export interface IModelUpgradeOperationInfo {

    modelId: string,
    operation: string,
    timeTaken: moment.Duration,
    wasUpgraded: boolean
}


export interface IUpgradeDatabaseResponse extends IBasicCommandResponse {

    upgradeCount: number,
    totalTimeTaken: Date,
    operationsExecuted: IModelUpgradeOperationInfo[]


}

export class DbAdminServices {

    // Directory function

    // Private declarations
    private rootApiUrl = "/api/1.0/dbadmin/";

    // Creates a new model
    updateIndexes = (): Promise<IBasicCommandResponse> =>
        FetchWrapper.sendCommandAndHandle(this.rootApiUrl + "updateindexes");

    deleteAllModels = (): Promise<IBasicCommandResponse> =>
        FetchWrapper.sendCommandAndHandle(this.rootApiUrl + "deleteallmodels");

    setNodeTypeField = (url: string): Promise<IBasicCommandResponse> => FetchWrapper.sendCommandAndHandle(url);

    performDbUpgrades(modelId: string, upgradeModelDatabases: boolean): Promise<IUpgradeDatabaseResponse> {

        //                                 data-url="@Url.RouteUrl(" PerformDBUpgrades", new {httproute="" })"
        const url = "/api/1.0/dbadmin/performdbupgrades";


        var request = { modelId: modelId, upgradeModelDatabases: upgradeModelDatabases };
        return FetchWrapper.sendCommandAndHandle(url, { method: "post", body: JSON.stringify(request) }, false)
            .then((response: IUpgradeDatabaseResponse) => response);

        //            return FetchWrapper.sendCommandAndHandle(url);

    }

    seedUsers = (): Promise<IBasicCommandResponse> =>
        FetchWrapper.sendCommandAndHandle("/api/1.0/command/seedUsersCommand", { method: "post", body: JSON.stringify({}) }, false);
}






// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.dbadmin-services.ts